import { withTheme } from 'travelopod-components';
import { compose } from 'recompose';

import withRouter from './withRouter';

export default () => compose(withRouter, withTheme);
